import React from 'react';
import MainLogo from '../../Logos/mainLogo/mainLogo';
import { useGeneralHooks } from '../../../Hooks/hooks';
import { IUser } from '../../../Interfaces/responseTypes';
import UserAvatar from '../../Avatars/UserAvatar/userAvatar';
import { useDrawerHooks } from '../../Drawer/drawer-hooks';
import HomeDrawerMobile from '../../Drawer/DrawerContents/HomeDrawerMobile/homeDrawerMobile';
import CustomDrawer from '../../Drawer/CustomDrawer/customDrawer';
import { HomeHeaderNavs } from '../../../Interfaces/componentTypes';
import { Menu } from '../../../Assets/Icons';
import styles from './homeHeader.module.scss';

interface IProps {
    user: IUser,
    onNavHandle: (title: HomeHeaderNavs) => void;
    active: HomeHeaderNavs
}

const HomeHeaderMobile: React.FC<IProps> = (props) => {
    const { user, onNavHandle, active } = props;
    const { openDrawer, onCloseDrawer, onOpenDrawer } = useDrawerHooks();
    const {smallScreen} = useGeneralHooks();

    return (
        <>
            <div className={styles.mobileHeader}>
                <MainLogo />
                <div className={styles.navContainerMobile}>
                    {!smallScreen && <UserAvatar user={user}  />}
                    <img src={Menu} alt='menuIcon' onClick={onOpenDrawer} />
                </div>
            </div>
            <CustomDrawer
                children={
                    <HomeDrawerMobile
                        user={user}
                        active={active}
                        onNavHandle={onNavHandle}
                        onCloseDrawer={onCloseDrawer}
                    />
                }
                open={openDrawer}
                onClose={onCloseDrawer}
            />
        </>
    )
}

export default HomeHeaderMobile
